import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import { MdModeEdit, MdClose } from "react-icons/md";
import { useForm, SubmitHandler } from "react-hook-form";
import { resetStatus, updateProfile } from "../../../store/user";
import Avatardefault from "../../../statics/illustrations/UserDefault.svg";
import { ErrorType } from "../../../store/errorType";
import { useEffect, useState } from "react";
import Message from "../../../components/message";
import Phoneinput from "./phoneInput";
import Addressinput from "./addressInput";
import Groupstates from "./groupStates";
import { Toaster } from "react-hot-toast";
import Swal from "sweetalert2";

// import { useParams } from "react-router-dom";
// import { getDetailCampaign } from "../../../store/campaign";
// import { FaCheckCircle } from "react-icons/fa";
// import Modal from "../../../components/modal";
// import { useModal } from "../../../customHooks/useModal";
// import Error from "../../../components/error";
// import { fetchData } from "../../../store/config";
// import Input from "../../../components/input";
// import useFetchtoken from "../../../customHooks/useFetchToken";
// import Zipcode from "./zipCode";
// import { RiErrorWarningLine } from "react-icons/ri";
// import Tooltipaction from "../../../components/Tooltip/tooltipAction";

export type FormValues = {
  name: string;
  email: string;
  phone: string;
  address: string;
  title: string;
  employee_city: string;
  employee_ext: string;
  employee_suit: string;
  employee_state: string;
  employee_zip_code: string;
  email_alternative: string;
};
const Profile = () => {
  /* dev varible */
  // const  QA = process.env.REACT_APP_QA
  const {
    extra,
    employee,
    name,
    email,
    id,
    id_company,
    id_occupation,
    public_user,
    status,
    errorMessage,
    errorType,
    id_employee,
  } = useAppSelector((state) => state.user);

  const dispatch = useAppDispatch();
  const {
    register,
    handleSubmit,
    setValue,
    clearErrors,
    setError,
    watch,
    formState: { errors },
  } = useForm<FormValues>();
  const [state, setstate] = useState<string | undefined>(undefined);
  const [file, setFile] = useState<File | string>("");
  const onSubmit: SubmitHandler<FormValues> = async (data) => {
    if (file !== "") {
      await dispatch(
        updateProfile({
          id,
          id_company,
          id_occupation,
          public_user,
          ...data,
          file_avatar: file,
        })
      );
      /* await dispatch(refreshtoken()) */
    } else {
      await dispatch(
        updateProfile({ id, id_company, id_occupation, public_user, ...data })
      );
      /* await dispatch(refreshtoken()) */
    }
  };

  const onChangeAvatar = (data: React.ChangeEvent<HTMLInputElement>) => {
    const file_target = data.target.files?.[0] || "";
    setFile(file_target);
    let aFileParts = ['<a id="a"><b id="b">hey!</b></a>'];
    let oMyBlob = new Blob(aFileParts, { type: "text/html" });
    let reader = new FileReader();
    let url = reader.readAsDataURL(file_target || oMyBlob);
    reader.onload = function (e) {
      /*  console.log(e.target?.result); */
      setstate(e.target?.result?.toString());
    };
    data.target.value = "";
  };

  const clearAvatar = () => {
    setstate(undefined);
    setFile("");
  };

  useEffect(() => {
    clearAvatar();
  }, [extra?.avatar]);

  useEffect(() => {
    setValue("name", name);
    setValue("email", email);
    setValue("title", extra?.title ? extra?.title : employee.title);
    setValue(
      "address",
      extra?.address ? extra?.address : employee.location_address1
    );
    /*     setValue('employee_ext', extra?.employee_ext?extra?.employee_ext: employee.work_extension) */
    setValue("employee_ext", extra?.employee_ext ? extra?.employee_ext : "");
    setValue(
      "employee_suit",
      extra?.employee_suit
        ? extra?.employee_suit
        : employee.location_address2
        ? employee.location_address2
        : ""
    );
    setValue(
      "employee_state",
      extra?.employee_state ? extra?.employee_state : employee.state
    );
    setValue(
      "employee_zip_code",
      extra?.employee_zip_code ? extra?.employee_zip_code : employee.zip_code
    );
    setValue(
      "employee_city",
      extra?.employee_city ? extra?.employee_city : employee.city
    );
    setValue(
      "email_alternative",
      extra?.email_alternative ? extra?.email_alternative : ""
    );
  }, [extra]);

  const checkKeyDown = (e: React.KeyboardEvent<HTMLFormElement>) => {
    if (e.code === "Enter" || e.code === "NumpadEnter") e.preventDefault();
  };

  useEffect(() => {
    if (status === "updateProfile_success") {
      Swal.fire({
        icon: "success",
        title: "Your profile has been updated",
        text: "The new data will be reflected in all your PURLs assets",
      });
      dispatch(resetStatus());
    }
  }, [status]);

  return (
    <>
      <form
        onSubmit={handleSubmit(onSubmit)}
        onKeyDown={(e) => checkKeyDown(e)}
        className="c-profile"
      >
        {/*       <div className="c-profile__header">
          <span className="c-profile__title">Settings</span>
      </div> */}
        <div className="c-profile__body">
          <span className="c-profile__title">Personal Information</span>
          <div className="c-profile__item-box-avatar">
            <span className="c-profile__item-title">Avatar</span>
            <div className="c-profile__box-avatar">
              <div className="c-profile__avatar">
                <img
                  className="c-profile__photo"
                  src={
                    state !== undefined
                      ? state
                      : extra?.avatar === "" ||
                        extra?.avatar === null ||
                        extra?.avatar === "default"
                      ? Avatardefault
                      : extra?.avatar
                  }
                  alt="edit photo profile profile"
                />
                <label className="c-profile__option-edit">
                  <MdModeEdit />
                  <input
                    type="file"
                    accept="image/png, image/jpeg"
                    onChange={(e) => onChangeAvatar(e)}
                  />
                </label>
                {file !== "" && (
                  <span
                    className="c-profile__option-delete"
                    onClick={clearAvatar}
                  >
                    <MdClose />
                  </span>
                )}
              </div>
              <span className="c-profile__description">
                Allowed file types: png, jpg, jpeg.
              </span>
            </div>
          </div>
          <div className="c-profile__item-box">
            <div className="c-input">
              <div className="c-input__header">
                <span className="c-input__title">Full Name</span>
              </div>
              <input
                type="text"
                className="c-input__input"
                {...register("name")}
              />
            </div>
          </div>
          <div className="c-profile__item-box">
            <div className="c-profile__colum">
              <div className="c-input">
                <div className="c-input__header">
                  <span className="c-input__title">E-Mail</span>
                </div>
                <input
                  type="text"
                  className="c-input__input"
                  {...register("email")}
                  disabled
                />
              </div>
            </div>
            <div className="c-profile__colum">
              <div className="c-input">
                <div className="c-input__header">
                  <span className="c-input__title">Alternative E-mail</span>
                </div>
                <input
                  type="text"
                  className={`c-input__input ${
                    errors.email_alternative && "c-input__input--error"
                  }`}
                  {...register("email_alternative", {
                    pattern: {
                      message: "enter a valid email",
                      value: /^\b[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}\b$/i,
                    },
                  })}
                />
                <span className="c-input__error">
                  {errors?.email_alternative?.message}
                </span>
              </div>
            </div>
          </div>

          <div className="c-profile__item-box">
            <div className="c-profile__colum">
              <div className="c-input">
                <div className="c-input__header">
                  <span className="c-input__title">Title</span>
                </div>
                <input
                  type="text"
                  className="c-input__input"
                  {...register("title", {
                    required: true,
                  })}
                />
              </div>
            </div>
            <div className="c-profile__colum">
              <div className="c-profile__item-box-two">
                <div className="c-profile__colum">
                  <Phoneinput
                    register={register}
                    setValue={setValue}
                    phone={extra?.phone ? extra.phone : employee.work_phone}
                  />
                </div>
                <div className="c-profile__colum">
                  <div className="c-input">
                    <div className="c-input__header">
                      <span className="c-input__title">Extension Phone</span>
                    </div>
                    <input
                      type="text"
                      className="c-input__input"
                      {...register("employee_ext")}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <span className="c-profile__subtitle">Location Information</span>
          <div className="c-profile__item-box">
            <div className="c-profile__colum">
              <Addressinput
                register={register}
                setValue={setValue}
                errors={errors}
              />
            </div>
            <div className="c-profile__colum">
              <div className="c-input">
                <div className="c-input__header">
                  <span className="c-input__title">Suite</span>
                </div>
                <input
                  type="text"
                  className="c-input__input"
                  {...register("employee_suit")}
                />
              </div>
            </div>
          </div>

          <Groupstates
            clearErrors={clearErrors}
            register={register}
            setValue={setValue}
            errors={errors}
            setError={setError}
            watch={watch}
          />
          {status === "updateProfile_rejected" &&
            errorType === ErrorType.ERROR_SERVER && (
              <Message
                type="error"
                message={errorMessage}
                clouse={() => dispatch(resetStatus())}
              />
            )}

          <div className="c-profile__footer">
            <button
              type="submit"
              className={`c-profile__save-changues ${
                status === "updateProfile_loading" &&
                `c-profile__save-changues--disabled`
              }`}
            >
              {status === "updateProfile_loading" ? (
                <>
                  <div className="spiner"></div> loading...
                </>
              ) : (
                <>Save changes</>
              )}
            </button>
          </div>
        </div>
      </form>
      <Toaster
        containerStyle={{
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
        }}
      />
    </>
  );
};

export default Profile;
